const MAX_DIM = 512;
const WEBP_QUALITY = 0.82;

/** Prépare l’avatar côté navigateur (512 px, WebP) — évite la conversion GD lente côté serveur. */
export async function prepareAccountPhotoForUpload(file: File): Promise<File> {
  if (!file.type.startsWith("image/") || file.size <= 0) {
    return file;
  }

  if (typeof createImageBitmap !== "function") {
    return file;
  }

  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      bitmap.close();
      return file;
    }

    ctx.drawImage(bitmap, 0, 0, width, height);
    bitmap.close();

    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob((b) => resolve(b), "image/webp", WEBP_QUALITY);
    });

    if (!blob || blob.size <= 0) {
      return file;
    }

    const base = file.name.replace(/\.[^.]+$/, "") || "avatar";
    return new File([blob], `${base}.webp`, { type: "image/webp", lastModified: Date.now() });
  } catch {
    return file;
  }
}
